export default "__VITE_ASSET__C3U8Nb12__"